<template>
  <div>
    <h5 class="mt-4">#Новый</h5>
    <fields-list :fields="fields" :item="item" :name="'new'" />
    <div class="buttons">
      <button @click="postItem(item)" class="btn btn-sm btn-success mr-2">
        <span class="ti-save"></span> Добавить
      </button>
      <button @click="close" class="btn btn-sm btn-danger">Отмена</button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, multiKeyInit } from "../../plugins/functions";
import FieldsList from "../Card/FieldsList";

export default {
  name: "PushItem",
  data() {
    return {
      item: {},
    };
  },
  components: {
    FieldsList,
  },
  props: {
    showCreate: {
      default: false,
    },
    setLink: {
      default: "",
    },
    fields: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
  },
  created() {
    let item = {};
    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }
    this.item = this.multiKeyInit(item, this, 1);
  },
  methods: {
    cardUpdate: cardUpdate,
    multiKeyInit: multiKeyInit,
    close() {
      this.item = {};
      this.$emit("close", true);
    },
    async postItem(item) {
      let result = await this.cardUpdate(
        this.setLink,
        { push: this.item },
        `post`
      );
      if (result) {
        this.$emit("push", this.multiKeyInit(result, this, 1));
        this.close();
      }
    },
  },
};
</script>